import {useRouter} from 'next/router';
import Container from 'react-bootstrap/Container'
import useSWR from 'swr';
import jsonApiClient from '../../utils/jsonApiClient'
import TutorSearchResultsList from '../TutorSearchResultsList'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faTimesCircle} from '@fortawesome/free-regular-svg-icons'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Card from 'react-bootstrap/Card'
import Skeleton from 'react-loading-skeleton'
import TutorRequestRequestContainer from '../tutorRequest/RequestContainer'


export default function TutorSearchContainer({subject, level, lat, lon, modality, page = 1, onPaginate}) {
  const router = useRouter()

  const search = {}
  if(subject) search.subject = subject
  if(level) search.level = level
  if(lat && lon) {
    search.lat = lat
    search.lon = lon
  }
  if(modality) search.modality = modality

  const fetcher = ({params}) => {
    const jsonApi = jsonApiClient()
    return jsonApi.findAll('tutor-profile', params)
  }

  const { data, error } = useSWR({
    url: `/tutor-profiles`,
    params: {
      filter: {
        query: search,
        employee_review_status: 'approved',
        only_available: true
      },
      include: 'subject-levels,subject-levels.subject,subject-levels.level,subjects,levels',
      page: {
        size: 25,
        number: page
      }
    }
  }, fetcher)

  if(error) return (
    <Container className="mb-5 pt-3">
      <div className="text-danger text-center mb-5">
        <div>
          <FontAwesomeIcon icon={faTimesCircle} size="lg" />
        </div>
        <div>Error fetching tutor profiles.</div>
        <div>
          <Button variant="link" onClick={() => router.reload()}>
            Try again
          </Button>
        </div>
      </div>
    </Container>
  )
  if(!data) return (
    <Container className="mb-5">
      <Skeleton height={50} className="mb-3" />
      <div className="text-center">
        <Card>
          <Card.Body>
            <Row>
              <Col xs={12} md={3} className="text-center">
                <Skeleton borderRadius={5} height={150} width={150} />
              </Col>

              <Col xs={12} md={6} className="mb-2 mb-md-0">
                <Skeleton count={5} />
              </Col>

              <Col xs={12} md={3}>
                <Skeleton count={3} />
                <Skeleton count={2} height={40} />
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </div>
    </Container>
  )

  const pageCount = data.meta['page-count']
  const recordCount = data.meta['record-count']

  return (
    <Container className="mb-5">
      {recordCount > 0 &&
        <>
          <h1 className="mb-3">{recordCount} Tutors Are Available</h1>

          <div className="mb-5">
            <TutorSearchResultsList results={data.data} subject={subject} level={level} />
          </div>
        </>
      }

      {pageCount > 1 &&
        <div className="text-center mb-5">
          <ButtonGroup className="mb-1">
            <Button size="sm" variant="outline-primary" disabled={page === 1} onClick={() => onPaginate('back')}>
              Back
            </Button>
            <Button size="sm" variant="outline-primary" disabled={page === pageCount} onClick={() => onPaginate('next')}>
              Next
            </Button>
          </ButtonGroup>

          <div className="small">
            Page {page} of {pageCount}
          </div>
        </div>
      }

      {recordCount === 0 &&
        <Row>
          <Col xs={12} md={8} className="mx-md-auto">
            <h1 className="mb-3">
              We Couldn&apos;t Find a Matching Tutor
            </h1>
            <h3 className="text-muted mb-4">
              Enter your details below and we&apos;ll get to work to find you a great tutor!
            </h3>

            <Card>
              <Card.Body>
                <TutorRequestRequestContainer subject={subject} level={level} modality={modality} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      }
    </Container>
  )
}
